import PropTypes from 'prop-types';
import React from 'react';
import Button from 'react-bootstrap/lib/Button';

import TutorialRecord from '../../records/Tutorial';
import connectToStores from '../../helpers/connectToStores';
import TutorialStore from '../../stores/TutorialStore';
import DimensionsStore from '../../stores/DimensionsStore';
import { KeyCodes } from '../../constants/AppConstants';
import TutorialActions from './../../actions/TutorialActions';
import t from '../../lib/I18n';
import config from '../../config';

import BaseModal from './BaseModal';
import ToggleInput from '../form/ToggleInput';
import OnEnterTrigger from '../general/OnEnterTrigger';

function _getStateFromStores (params) {
    const forceHide = Boolean((params.hideMobile && DimensionsStore.isMobileWidth())
        || (params.hideTablet && DimensionsStore.isTabletWidth())
        || (params.hideDesktop && DimensionsStore.isDesktopWidth()));

    return {
        tutorial: TutorialStore.getTutorialByName(params.name),
        dismissed: TutorialStore.isTutorialDismissed(params.name),
        forceHide
    };
}

export class Tutorial extends React.PureComponent {
    static propTypes = {
        name: PropTypes.string.isRequired,
        tutorial: PropTypes.instanceOf(TutorialRecord),
        dismissed: PropTypes.bool,
        className: PropTypes.string,
        children: PropTypes.node,
        hideMobile: PropTypes.bool,
        hideTablet: PropTypes.bool,
        hideDesktop: PropTypes.bool,
        forceHide: PropTypes.bool,
        notAccessible: PropTypes.bool
    };

    static defaultProps = {
        tutorial: null,
        className: '',
        children: null,
        dismissed: false,
        hideMobile: false,
        hideTablet: false,
        hideDesktop: false,
        forceHide: false,
        notAccessible: false
    };

    state = {
        open: this.props.tutorial && this.props.tutorial.defaultOpen && !this.props.dismissed,
        dismissed: this.props.dismissed,
        tutorial: this.props.tutorial
    };

    UNSAFE_componentWillReceiveProps (newProps) {
        if (newProps.tutorial && !newProps.dismissed && newProps.dismissed !== this.props.dismissed) {
            this.setState({
                open: false,
                dismissed: newProps.dismissed
            });
        }
    }

    UNSAFE_componentWillMount(){
        document.addEventListener("keydown", this.handleKeyDown);
    }


    componentWillUnmount() {
        document.removeEventListener("keydown", this.handleKeyDown);
    }

    toggleModal = () => {
        const open = !this.state.open;
        const { tutorial, dismissed } = this.state;
        TutorialActions.toggle(
            this.props.name,
            {
                open,
                dismissed,
                lastStage: tutorial.stageCount(),
                currentStage: tutorial.currentIndex + 1
            }
        );
        this.setState({
            open,
            tutorial: this.state.tutorial.setCurrentStage(0)
        });
    };

    handleDismissedToggle = () => {
        this.setState({ dismissed: !this.state.dismissed });
    };

    movePrev = () => {
        this.setState({ tutorial: this.state.tutorial.moveToPrev() });
    };

    moveNext = () => {
        this.setState({ tutorial: this.state.tutorial.moveToNext() });
    };

    handleKeyDown = (event) => {
        if (this.props.tutorial && event.keyCode === KeyCodes.LEFT_ARROW) {
            this.movePrev();
        }

        if (this.props.tutorial && event.keyCode === KeyCodes.RIGHT_ARROW) {
            this.moveNext();
        }
    };

    renderHeader (currentStage) {
        const { tutorial } = this.state;
        return (
            <h1 className="modal-title text-left">
                { t(currentStage.title) }
                {!tutorial.hideProgression &&
                    <span className="pull-right">{ `(${tutorial.currentIndex + 1}/${tutorial.stageCount()})` }</span>
                }
            </h1>
        );
    }

    renderFooter () {
        const { dismissed, tutorial} = this.state;
        return (
            <div>
                <div className="pull-left">
                    <span className="pull-left"><Button
                        bsStyle="default"
                        onClick={ this.toggleModal }
                        className="close btn-md">
                        { t('button.text.close') }
                    </Button>&nbsp;&nbsp;</span>
                    { tutorial.showToggle() && <ToggleInput checked={ dismissed } label={ t(`tutorial.dismiss-checkbox-label`) } onChange={ this.handleDismissedToggle }/> }
                </div>
                <span className="pull-right">
                    { tutorial.hasPrev() && <span>&nbsp;<Button
                            bsStyle="default"
                            onClick={ this.movePrev }
                            className="close btn-md btn-primary">
                            { t('button.text.prev-tip') }
                        </Button>
                    </span> }
                    { tutorial.hasNext() && <span>&nbsp;<Button
                            bsStyle="default"
                            onClick={ this.moveNext }
                            className="close btn-md btn-primary">
                            { t('button.text.next-tip') }
                        </Button>
                    </span> }
                </span>
            </div>
        );
    }

    render () {
        const { forceHide, tutorial, notAccessible } = this.props;
        if (forceHide || !tutorial) {
            return null;
        }

        const stage = this.state.tutorial.getCurrentStage();
        const modalProps = {
            show: this.state.open,
            onClose: this.toggleModal,
            className: 'modal--sm tutorial-modal',
            header: this.renderHeader(stage),
            footer: this.renderFooter()
        };
        const imageName = `${config.get('brand')}/${this.props.name}-${stage.name}.png`;

        let accessibilityProps = {};
        if (notAccessible) { Object.assign(accessibilityProps, { tabIndex: "-1", ariaHidden: "true" }); }

        return (
            <span className={ `tutorial ${this.props.className}` }>
                <OnEnterTrigger element="span" className="tutorial__trigger" role="button" onClick={ this.toggleModal } { ...accessibilityProps }>
                    { this.props.children }
                </OnEnterTrigger>
                <BaseModal { ...modalProps }>
                    { stage.image && !stage.video && <div className="tutorial-modal__image">
                        <span className="image" style={ {backgroundImage: `url(/images/tutorials/${imageName})`} }/>
                        <span className="loader"/>
                    </div> }
                    { stage.video && !stage.image && <div className="tutorial-modal__image">
                        <iframe height="280" width="100%" className="image" src={ `https://www.youtube.com/embed/${stage.video}?autoplay=1&modestbranding=1&rel=0&iv_load_policy=3` } frameBorder="0" allow="autoplay; encrypted-media" allowFullscreen/>
                        <span className="loader"/>
                    </div> }
                    <p>{ t(stage.text) }</p>
                </BaseModal>
            </span>
        );

    }
}

export default connectToStores([TutorialStore, DimensionsStore], _getStateFromStores)(Tutorial);



// WEBPACK FOOTER //
// ./src/components/general/Tutorial.js